<template>
  <div style="height:100%">

    <el-card class="box-card" :body-style="{padding:'4px'}" style="display: flex;flex-direction: column;height: 100%;">
      <div slot="header">
        <b-row style="padding: 4px; ">
        <b-col sm="auto" style="padding-top: 6px; padding-right: 2px">
          <i class="iconfont icon-search"></i>
        </b-col>
        <b-col sm="auto" class="pl-1">
          工艺版本1：
          <el-input placeholder="请输入工艺编号" v-model="RouteVersion1" style="width:200px" class="mr-1" clearable></el-input>
          工艺版本2：
          <el-input placeholder="请输入工艺编号" v-model="RouteVersion2" style="width:200px" clearable></el-input>
        </b-col>
        <b-col class="pl-1">
          <QueryButton @on_query="getDiff" :label="$t('common.query')"></QueryButton>
          <el-checkbox class="ml-2" v-model="folding" @change="foldingChanged">仅差异</el-checkbox>
        </b-col>
      </b-row>
      </div>
      <div name="code_diff_div" style="height:100%;border:1px solid grey; overflow-y: auto;">
        <code-diff v-show="isShow" :highlight="false" fileName="BomVersion" :context="100000" :old-string="prev" :new-string="current"
          output-format="side-by-side" :renderNothingWhenEmpty="false" :isShowNoChange="true" :trim="true" :drawFileList="false"
          :noDiffLineFeed="false" />
        <el-empty v-show="!isShow" :image-size="200"></el-empty>
      </div>
    </el-card>

  </div>
</template>
<script>
import QueryButton from "../components/base/QueryButton.vue";
import * as RouteVersionController from "../../controllers/sd/RouteVersionController";
import * as RouteController from "../../controllers/sd/RouteController";
import * as CostItemsController from "../../controllers/sd/CostItemsController";
import * as InventBomController from "../../controllers/sd/InventBomController";
import { CodeDiff } from 'v-code-diff'

export default {
  components: {
    CodeDiff,
    QueryButton
  },
  data() {
    return {
      detailFields: RouteController.fields.route_detail,
      detailOprFields: RouteController.fields.route_detail_opr,
      fieldKeys: [],
      showContext: false,
      RouteVersion1: "",
      RouteVersion2: "",
      prev: "",
      current: "",
      isShow: false,
      folding: false,
    }
  },
  mounted() {
    // this.getDiff();
    this.fieldKeys = _.union(this.detailFields, this.detailOprFields)

  },
  methods: {
    async getDiff(cb) {
      cb(null);
      if (this.RouteVersion1 == "") {
        this.msgToasts("请输入工艺版本1！", "info");
        return;
      }
      if (this.RouteVersion2 == "") {
        this.msgToasts("请输入工艺版本2！", "info");
        return;
      }
      let orig1 = null, orig2 = null;
      this.RouteVersion1 = _.trim(this.RouteVersion1);
      this.RouteVersion2 = _.trim(this.RouteVersion2);
      this.showContext = true;
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let p = [{ is_deleted: 0, RouteId: { "=": this.RouteVersion1 } }, { is_deleted: 0, RouteId: { "=": this.RouteVersion2 } }];

      let _result = await RouteVersionController.methods.getDataDiff(p);
      if (!_.isNull(_result) && _result && _result.length > 0 && _result[0]) {
        let dt = _result[0];
        for (var i in dt) {
          if (dt[i]) {
            let _rt1 = await CostItemsController.methods.execCalcRsrcCost({
              ItemId: dt[i].ItemId,
              ProductQty: 0,
              AccountNum: null,
              dataAreaId: dt[i].dataAreaId,
              BomID: "",
              RouteID: dt[i].RouteId
            });
            let _rt2 = await InventBomController.methods.getBomTree({ ItemId: dt[i].ItemId, BomID: "" });
            if (!_.isNull(_rt1) && _rt1 && _rt1.length > 0 && !_.isNull(_rt2) && _rt2 && _rt2.length > 0) {
              let dt1 = _rt1[0], dt2 = _rt2[0], rm = {};
              let ck = dt[i].ItemId + ":" + dt[i].Name;
              this.handleRouteItems(dt1, dt[i].ItemId, ck, rm);
              this.setJsonData(dt1, dt2, rm[ck], { ItemId: dt[i].ItemId });
              if (dt[i].RouteId == this.RouteVersion1) {
                orig1 = JSON.stringify(_.cloneDeep(rm), null, 4)
              }
              if (dt[i].RouteId == this.RouteVersion2) {
                orig2 = JSON.stringify(_.cloneDeep(rm), null, 4)
              }
            }
          }
        }
      }
      if (orig1 == null) {
        this.msgToasts("工艺版本1暂无数据，无法对比！", "info");
        loading.close();
        return;
      }
      else if (orig2 == null) {
        this.msgToasts("工艺版本2暂无数据，无法对比！", "info");
        loading.close();
        return;
      }
      this.isShow = true
      this.prev = orig1;
      this.current = orig2
      loading.close();
    },
    setJsonData(dt1, dt2, m, bomFilterParams) {
      let theBomItems = _.filter(dt2, bomFilterParams);
      _.each(theBomItems, (bm) => {
        let ck = bm.DetailItemId + ":" + bm.NameAlias;
        this.handleRouteItems(dt1, bm.DetailItemId, ck, m);
        this.setJsonData(dt1, dt2, m, bm.DetailItemId);
      })
    },
    handleRouteItems(dt1, itemId, ck, m) {
      let routeItems = _.filter(dt1, { ItemId: itemId });
      if (routeItems && routeItems.length > 0) {
        m[ck] = {};
        _.each(routeItems, (t) => {
          let rm = _.cloneDeep(t);
          let route_ck = t.OprNum + ":" + t.OprId;
          m[ck][route_ck] = rm;
          if (rm) {
            for (var k in rm) {
              let tm = _.find(this.fieldKeys, { key: k });
              if (tm && k != "id") {
                rm[tm.label] = rm[k];
              }
              if (k != route_ck) {
                delete rm[k]
              }
            }
          }
        })
      }
    },
    foldingChanged() {
      let cntx_dt = document.getElementsByClassName("d2h-cntx");
      // console.log(cntx_dt)
      _.each(cntx_dt, (t) => {
        if (t.className == "d2h-cntx")
          t.parentElement.style.display = this.folding ? "none" : "";
      })
    }
  }
}
</script>
<style scoped>
.d2h-file-side-diff {
  margin-bottom: -5px;
  /* overflow: scroll; */
}
.d2h-code-side-linenumber {
  padding: 0 0.5rem;
  position: relative;
  line-height: 20px;
  height: 20px;
  display: table-cell;
}

.el-card :deep(.el-card__body){
  flex: 1;
}
</style>
